import clsx from "clsx";

export default function Spinner({ className }: { className?: string }) {
  return (
    <div className={clsx("flex items-center justify-center", className)}>
      <div className="w-6 h-6 border-2 border-coral/30 border-t-coral rounded-full animate-spin" />
    </div>
  );
}
